import axios from "axios";

const API_ENDPOINT = global.API_URI || "http://mm-chat.demo2.mixmedia.com/api";
const ENABLE_ZOHO_AUTH = window.ZOHO_AUTH || false;

const http = axios.create({
    baseURL: API_ENDPOINT,
});

http.interceptors.response.use(function (resp) {
    let json = resp.data;
    if (json && json.status == 1) {
        return json.data;
    }
    if (json && json.error) {
        if (json.error.code == ERROR_CODE.AUTH) {
        }
        return Promise.reject(json.error);
    }

    return Promise.reject();
});

export default {
    loadConfig() {
        if (!ENABLE_ZOHO_AUTH) {
            return Promise.reject(new Error("Not enable zoho auth"));
        }
        return http.get("/auth/zoho/config")
            .then(({auth_url}) => {
                return auth_url;
            });
    }
}
